// @flow


import { render } from '../../../utils';

const withRenderer = (options) => (Constructor: Class<*>) => {
	return class extends Constructor {
		constructor (...args: *[]) {
			super(...args);

			render(options.selector, {
				model: this,
				template: options.template,
			});
		}
	};
};


export default withRenderer;
